import { useAnalytics } from "@codat/analytics";
import { useCodatAuth } from "@codat/client-cookie-manager";
import { Menu } from "@codat/orchard-ui";
import ExitIcon from "icons/ExitIcon";
import * as React from "react";
import Cookies from "universal-cookie";

import config from "config";
import { CLIENT_ID_COOKIE_KEY } from "config/auth";

const LogOutButton = () => {
  const { userManager, authType, clearAuth0Cookies } = useCodatAuth();
  const { sendEvent } = useAnalytics();

  const cookies = new Cookies();

  const handleLogOut = async () => {
    try {
      cookies.remove(CLIENT_ID_COOKIE_KEY, {
        domain: ".codat.io",
        path: "/",
      });

      if (authType === "OIDC") {
        userManager.revokeAccessToken();
        userManager.removeUser();
      } else {
        // Clear cookies that identify a user as using Auth0, so they do not interfere with OIDC login
        clearAuth0Cookies({
          domain: ".codat.io",
        });
      }

      const returnToUrl =
        authType === "OIDC"
          ? `${
              config.USER_MANAGEMENT_URL
            }/signin?redirectUrl=${encodeURIComponent(window.location.href)}`
          : config.PORTAL_URL;

      await userManager.signoutRedirect({
        logoutParams: {
          federated: false,
          client_id: config.AUTH0_CLIENTID,
          returnTo: returnToUrl,
        },
      });
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error("Error attempting to sign out", e);
    }
  };

  return (
    <Menu.Item
      id="sign-out-button"
      onClick={() => {
        sendEvent("Sign Out Button - Click");
        handleLogOut();
      }}
      label="Sign out"
      data-testid="sign-out-button"
      icon={<ExitIcon />}
    />
  );
};

export default LogOutButton;
